import { render, staticRenderFns } from "./Formular.vue?vue&type=template&id=00a25cc4&scoped=true"
import script from "./Formular.vue?vue&type=script&lang=js"
export * from "./Formular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a25cc4",
  null
  
)

export default component.exports